import { instance as axios } from "../../configs/axios";

export default {
  getBrandsByUser: () => axios.get("/Brand/GetBrandsByUser"),
};
